import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserRestrictionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentUserRestrictionsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly restrictions: { readonly __typename?: 'AccountsRestriction', readonly projectCreationRestricted: boolean } } | null };


export const GetCurrentUserRestrictionsDocument = gql`
    query GetCurrentUserRestrictions {
  currentUser {
    restrictions {
      projectCreationRestricted
    }
  }
}
    `;

/**
 * __useGetCurrentUserRestrictionsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserRestrictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserRestrictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserRestrictionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserRestrictionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserRestrictionsQueryPage, GetCurrentUserRestrictionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserRestrictionsQueryPage, GetCurrentUserRestrictionsQueryVariables>(GetCurrentUserRestrictionsDocument, options);
      }
export function useGetCurrentUserRestrictionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserRestrictionsQueryPage, GetCurrentUserRestrictionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserRestrictionsQueryPage, GetCurrentUserRestrictionsQueryVariables>(GetCurrentUserRestrictionsDocument, options);
        }
export function useGetCurrentUserRestrictionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserRestrictionsQueryPage, GetCurrentUserRestrictionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserRestrictionsQueryPage, GetCurrentUserRestrictionsQueryVariables>(GetCurrentUserRestrictionsDocument, options);
        }
export type GetCurrentUserRestrictionsQueryHookResult = ReturnType<typeof useGetCurrentUserRestrictionsQuery>;
export type GetCurrentUserRestrictionsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserRestrictionsLazyQuery>;
export type GetCurrentUserRestrictionsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserRestrictionsSuspenseQuery>;
export type GetCurrentUserRestrictionsQueryResult = Apollo.QueryResult<GetCurrentUserRestrictionsQueryPage, GetCurrentUserRestrictionsQueryVariables>;